
	class CustomBlogPosts extends HTMLElement {
		constructor() {
			super();
			this.currentPage = 1;
			this.postsPerPage = 8; // number of posts per page
			this.all_blog_posts = [];
			this.startFetching();
		}

		async startFetching() {

			const total_articles = window.article_count || 0;
	
			if (!total_articles) {
				this.renderPosts([]);
				return;
			}
	
			const pagesCount = total_articles > 50 ? Math.ceil(total_articles / 50) : 1;
	
			try {
	
				const responses = await Promise.all(
					Array.from({ length: pagesCount }, (_, i) =>
						fetch(`/blogs/blog?section_id=main-blog&page=${i + 1}`)
					)
				);
	
				const htmlPages = await Promise.all(responses.map(r => r.text()));
	
				htmlPages.forEach(htmlString => {
	
					const parser = new DOMParser();
					const doc = parser.parseFromString(htmlString, 'text/html');
	
					const jsonElement = doc.querySelector('[data-blog-json]');
	
					if (!jsonElement) return;
	
					try {
	
						const jsonData = JSON.parse(jsonElement.textContent);
	
						Object.values(jsonData).forEach(post => {
							this.all_blog_posts.push(post);
						});
	
					} catch (err) {
						console.error('JSON parse error', err);
					}
	
				});
	
				this.renderPage(this.currentPage);
	
			} catch (error) {
				console.error('Blog fetch failed', error);
				this.renderPosts([]);
			}
		}
		
		renderPage(pageNumber) {
			const startIndex = (pageNumber - 1) * this.postsPerPage;
			const endIndex = startIndex + this.postsPerPage;
			const postsToRender = this.all_blog_posts.slice(startIndex, endIndex);

		this.renderPosts(postsToRender);
		this.renderPagination();
		requestAnimationFrame(() => {
			this.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
		}

		renderPosts(posts) {
			this.innerHTML = '';
			if (!posts.length) {
				this.innerHTML = `<p>No blog posts found.</p>`;
				return;
			}

			posts.forEach((post, index) => {
				let htmlBlock = '';
				if (index === 0 || index === 4) {
					htmlBlock = this.renderLargePost(post);
				} else {
					htmlBlock = this.renderSmallPost(post);
				}
				this.innerHTML += htmlBlock;
			});
		}

		renderPagination() {

			const totalPages = Math.ceil(this.all_blog_posts.length / this.postsPerPage);
			if (totalPages <= 1) return;

			const maxVisible = 5; // Max numbers to show before using "..."
			let startPage = Math.max(this.currentPage - Math.floor(maxVisible / 2), 1);
			let endPage = startPage + maxVisible - 1;
			if (endPage > totalPages) {
				endPage = totalPages;
				startPage = Math.max(endPage - maxVisible + 1, 1);
			}

			const existingPagination = this.querySelector('pagination-theme');
			if (existingPagination) existingPagination.remove();

			let pagesHTML = '';

			// Prev button
			if (this.currentPage > 1) {
				pagesHTML += `<button class="prev-btn"><svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M11 4H6H1M1 4L4.28467 1M1 4L4.28467 7" stroke="var(--color-accent)" stroke-linecap="round" stroke-linejoin="round"/>
										</svg></button>`;
			}

			// First page
			if (startPage > 1) {
				pagesHTML += `<span class="page" data-page="1"><a href="#">1</a></span>`;
				if (startPage > 2) pagesHTML += `<span class="dots">…</span>`;
			}

			// Page numbers
			for (let i = startPage; i <= endPage; i++) {
				pagesHTML += `<span class="page ${i === this.currentPage ? 'current' : ''}" data-page="${i}"><a href="#">${i}</a></span>`;
			}

			// Last page
			if (endPage < totalPages) {
				if (endPage < totalPages - 1) pagesHTML += `<span class="dots">…</span>`;
				pagesHTML += `<span class="page" data-page="${totalPages}"><a href="#">${totalPages}</a></span>`;
			}

			if (this.currentPage < totalPages) {
				pagesHTML += `<button class="next-btn"><svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1 4H6H11M11 4L7.71533 1M11 4L7.71533 7" stroke="var(--color-accent)" stroke-linecap="round" stroke-linejoin="round"/>
											</svg></button>`;
			}

			const paginationHTML = `
				<pagination-theme class="pagination pagination-type--paginated" style="width: 100%;">
					<div class="row">
						<div class="small-12 columns">
							<div class="page-numbers nav-links">
								${pagesHTML}
							</div>
						</div>
					</div>
				</pagination-theme>
			`;

			this.insertAdjacentHTML('beforeend', paginationHTML);
			// Event listeners for numbered pages
			this.querySelectorAll('.page a').forEach(link => {
				link.addEventListener('click', e => {
					e.preventDefault();
					const page = parseInt(link.parentElement.dataset.page);
					if (!isNaN(page)) {
						this.currentPage = page;
						this.renderPage(this.currentPage);
					}
				});
			});

			// Previous button
			const prevBtn = this.querySelector('.prev-btn');
			if (prevBtn) prevBtn.addEventListener('click', () => {
				if (this.currentPage > 1) {
					this.currentPage--;
					this.renderPage(this.currentPage);
				}
			});
			const nextBtn = this.querySelector('.next-btn');
			if (nextBtn) nextBtn.addEventListener('click', () => {
				if (this.currentPage < totalPages) {
					this.currentPage++;
					this.renderPage(this.currentPage);
				}
			});
		}

	renderLargePost(post, image_ratio = 'adapt') {
		let ratio = 1;
			let image_sizes = '';
			switch(image_ratio) {
				case 'adapt': image_sizes = '880x0'; if(post.image?.aspect_ratio) ratio = post.image.aspect_ratio; break;
				case 'square': image_sizes = '880x880,1320x1320'; ratio = 1; break;
				case 'landscape': image_sizes = '880x550,1320x825'; ratio = 1.6; break;
				case 'portrait': image_sizes = '880x1100,880x1650'; ratio = 0.8; break;
			}
			const ratioPercent = (1 / ratio) * 100;

			return `
			<div class="small-12 medium-9 columns blog-post blog-post--large" style="margin-inline: auto;">
				<figure class="featured-image aspect-ratio" style="--ratio-percent: ${ratioPercent}%; --ratio-percent-medium: ${0.66 / ratio * 100}%;">
					<a href="${post.url}" title="${post.title}">
						${post.image ? `<img src="${post.image}" alt="${post.title}" sizes="${image_sizes}">` 
									: `<div class="thb-placeholder"></div>`}
					</a>
				</figure>
				<div class="blog-post--content">
					<aside class="post-meta">${post.published_at}</aside>
					<h3 class="h6"><a href="${post.url}" title="${post.title}">${post.title}</a></h3>
					<div class="post-excerpt"><p>${post.excerpt}</p></div>
					<a href="${post.url}" title="${post.title}" class="text-button read-more">Read More</a>
				</div>
			</div>`;
		}

		renderSmallPost(post, image_ratio = 'adapt') {
			let ratio = 1;
			let image_sizes = '';

			switch(image_ratio) {
				case 'adapt': image_sizes = '320x0,640x0'; if(post.image?.aspect_ratio) ratio = post.image.aspect_ratio; break;
				case 'square': image_sizes = '320x320,640x640'; ratio = 1; break;
				case 'landscape': image_sizes = '320x200,640x400'; ratio = 1.6; break;
				case 'portrait': image_sizes = '320x400,640x800'; ratio = 0.8; break;
			}
			const ratioPercent = (1 / ratio) * 100;
			return `
			<div class="small-12 medium-4 columns blog-post">
				<figure class="featured-image aspect-ratio" style="--ratio-percent: ${ratioPercent}%;">
					<a href="${post.url}" title="${post.title}">
						${post.image ? `<img src="${post.image}" alt="${post.title}" sizes="${image_sizes}">` 
									: `<div class="thb-placeholder"></div>`}
					</a>
				</figure>
				<aside class="post-meta">${post.published_at}</aside>
				<h3 class="h6"><a href="${post.url}" title="${post.title}">${post.title}</a></h3>
				<div class="post-excerpt"><p>${post.excerpt}</p></div>
				<a href="${post.url}" title="${post.title}" class="text-button read-more">Read More</a>
			</div>`;
		}
	}
customElements.define('custom-blog-posts', CustomBlogPosts);